import tw, { styled } from 'twin.macro';

export const HeaderText = styled.h1`
  ${tw`sm:col-span-4 md:col-span-8 lg:col-span-12 xl:col-span-12`}
  ${tw`italic font-extrabold text-light-high mt-16 mb-30 text-center`}
  font-size: 48px;
  line-height: 120%;
  letter-spacing: -2.4px;
`;

export const Content = styled.div`
  ${tw`sm:col-span-4 md:col-span-8`}
  ${tw`lg:col-start-2 lg:col-end-12`};
  ${tw`xl:col-start-2 xl:col-end-12`};
  ${tw`m-3 text-left break-words`}
`;
